import {Component, Input, OnChanges, OnDestroy} from '@angular/core';
import {ApiArticle} from '@api/articles';
import {Subject} from 'rxjs';
import {ArticleService} from '@iw-shop/article/services/article.service';
import {Store} from '@ngrx/store';
import {AppState} from '@store/state/app.state';
import {takeUntil} from 'rxjs/operators';
import {PricingModel} from '@iw-shop/article/model/pricing.model';
import {faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import {getSelectedCustomer} from "@store/selectors/user.selector";

@Component({
    selector: 'iw-shop-article-price-quantity-discount-button',
    standalone: false,
    templateUrl: './quantity-discount-button.component.html',
    styleUrls: ['./quantity-discount-button.component.scss']
})
export class ArticlePriceQuantityDiscountButtonComponent implements OnDestroy, OnChanges {

    @Input() article!: ApiArticle;
    @Input() quantityNetPriceLessThan: number | null = null;


    destroy$: Subject<boolean> = new Subject<boolean>();

    customerPriceMode: 'net' | 'gross' = 'gross';
    pricingModel: PricingModel;

    constructor(public articleService: ArticleService, private store: Store<AppState>) {
        this.pricingModel = new PricingModel(this.articleService);
        this.store.select(getSelectedCustomer)
            .pipe(
                takeUntil(this.destroy$)
            )
            .subscribe(
                r => {
                    if (r?.priceMode) {
                        this.pricingModel.priceMode = r.priceMode;
                        this.customerPriceMode = r.priceMode;
                    }
                }
            );
    }

    ngOnChanges() {
        this.pricingModel.article = this.article;
        this.pricingModel.setPrices(this.quantityNetPriceLessThan);
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }

    protected readonly faInfoCircle = faInfoCircle;
}
